import { useEffect, useState } from "react";
import BarChart from '../../components/Organization/Usage/BarChart'


export default function UsageTab() {
  const [chartData , setChartData] = useState([])
   const token = localStorage.getItem('token');
   const userId = localStorage.getItem('UserId');
 
   const fetchData = async () => {
     try {
       const response = await fetch(`${process.env.REACT_APP_API_ROOT}/api/payment/credits/?UserId=${userId}`, {
         method: 'GET',
         headers: {
           'Content-Type': 'application/json',
           Authorization: `Bearer ${token}`,
         },
       });
       
       if (response.ok) {
         const dataa = await response.json();
         if (Array.isArray(dataa.data)) {
          const filteredData = dataa?.data?.filter(item => item.app_name == "Conversational AI");
          setChartData(filteredData);
        } else {
          setChartData([]);
        }
      }

     } catch (error) {
       console.log('Error:', error.message);
     }
   };
   
   useEffect(() => {
     fetchData();
   }, []);

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">Usage</h2>
        <p className="text-sm text-gray-600">Below is the credit usage graph in comparison to days.</p>
      </div>
       
      <div className="bg-white p-6 rounded-lg border border-gray-200 w-full">
        <BarChart chartData={chartData} />
      </div> 
    </div>
  )
}
